// Email configuration
export const EMAIL_CONFIG = {
  // Mailgun configuration
  MAILGUN: {
    API_KEY: '89f607af698700fd7a7c80c2d5635115-16bc1610-7285f0d3',
    DOMAIN: 'mg.rentabahay.com', // Mailgun production domain configured
    RECIPIENT: 'vloremia@gmail.com',
  },
  
  // Fallback settings
  FALLBACK: {
    ENABLED: true, // Whether to fall back to mailto: links if Mailgun fails
  },
  
  // Rate limiting (for future implementation)
  RATE_LIMITING: {
    MAX_EMAILS_PER_HOUR: 10,
    MAX_EMAILS_PER_DAY: 50,
  }
};

// Helper function to get Mailgun URL
export const getMailgunUrl = () => {
  if (EMAIL_CONFIG.MAILGUN.DOMAIN === 'YOUR_MAILGUN_DOMAIN') {
    throw new Error('Please configure your Mailgun domain in src/lib/config/email.ts');
  }
  return `https://api.mailgun.net/v3/${EMAIL_CONFIG.MAILGUN.DOMAIN}/messages`;
};
